import { SET_PRODUCTION_PLAN_UPDATED_AT } from './ProductionPlan/constants';

export const setProductionPlanningPlanUpdatedAt = (payload) => {
  return { type: SET_PRODUCTION_PLAN_UPDATED_AT, payload };
};
